(function () {
  var FALLBACK_MS  = 480;
  var AUTOPLAY_MS  = 3000;

  function getSlides(container) {
    var script = container.querySelector('script[data-lux-chapters-data]');
    if (!script) return null;
    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      return null;
    }
  }

  function initSection(container) {
    if (!container || container.getAttribute('data-lux-chapters-ready') === 'true') return;

    var slides = getSlides(container);
    if (!slides || !slides.length) return;

    container.setAttribute('data-lux-chapters-ready', 'true');

    var featured      = container.querySelector('[data-lux-featured]');
    var content       = container.querySelector('[data-lux-content]');
    var img           = container.querySelector('[data-lux-featured-img]');
    var titleEl       = container.querySelector('[data-lux-title]');
    var descEl        = container.querySelector('[data-lux-description]');
    var thumbs        = Array.prototype.slice.call(container.querySelectorAll('[data-lux-thumb]'));
    var progress      = container.querySelector('[data-lux-progress]');
    var progressTrack = container.querySelector('.lux-chapters__progress-track');
    var progressWrap  = container.querySelector('.lux-chapters__progress');

    var animTargets = [featured, content].filter(Boolean);
    var active  = 0;
    var locked  = false;
    var timer   = null;

    // ── Build bullet nav dynamically ──
    var bulletsWrap = document.createElement('div');
    bulletsWrap.className = 'lux-chapters__bullets';
    bulletsWrap.setAttribute('role', 'tablist');
    bulletsWrap.setAttribute('aria-label', 'Slide navigation');

    var bulletEls = slides.map(function (_, i) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'lux-chapters__bullet' + (i === 0 ? ' is-active' : '');
      btn.setAttribute('role', 'tab');
      btn.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
      btn.setAttribute('aria-label', 'Go to slide ' + (i + 1));
      btn.setAttribute('data-index', String(i));
      bulletsWrap.appendChild(btn);
      return btn;
    });

    if (progressWrap && progressWrap.parentNode) {
      progressWrap.parentNode.insertBefore(bulletsWrap, progressWrap.nextSibling);
    }

    // ── Autoplay ──
    function startAutoplay() {
      stopAutoplay();
      timer = setInterval(function () {
        var next = (active + 1) % slides.length;
        goTo(next);
      }, AUTOPLAY_MS);
    }

    function stopAutoplay() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    // Pause on hover/focus, resume on leave
    container.addEventListener('mouseenter', stopAutoplay);
    container.addEventListener('focusin',    stopAutoplay);
    container.addEventListener('mouseleave', startAutoplay);
    container.addEventListener('focusout',   function (e) {
      // Only restart if focus left the container entirely
      if (!container.contains(e.relatedTarget)) startAutoplay();
    });

    // Pause when tab is hidden, resume when visible
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') {
        stopAutoplay();
      } else {
        startAutoplay();
      }
    });

    // ── Helpers ──
    function setProgress(index) {
      if (progress) progress.style.setProperty('--lux-progress-index', String(index));
    }

    function syncBullets(index) {
      bulletEls.forEach(function (btn, i) {
        var on = i === index;
        btn.classList.toggle('is-active', on);
        btn.setAttribute('aria-selected', on ? 'true' : 'false');
      });
    }

    function applySlide(index) {
      var s = slides[index];
      if (!s) return;

      if (img && s.main) {
        img.src    = s.main.src;
        img.srcset = s.main.srcset;
        img.width  = s.main.width;
        img.height = s.main.height;
        img.alt    = s.main.alt || '';
      }

      if (titleEl) titleEl.textContent = s.title || '';
      if (descEl)  descEl.innerHTML    = s.description || '';

      thumbs.forEach(function (btn, i) {
        btn.classList.toggle('is-active', i === index);
        btn.setAttribute('aria-pressed', i === index ? 'true' : 'false');
      });

      setProgress(index);
      syncBullets(index);
      active = index;
    }

    function finishTransition(index) {
      applySlide(index);
      animTargets.forEach(function (el) {
        el.classList.remove('is-transition-out');
        el.classList.add('is-teleport');
        el.classList.add('is-transition-in');
      });
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          animTargets.forEach(function (el) { el.classList.remove('is-teleport'); });
          requestAnimationFrame(function () {
            animTargets.forEach(function (el) { el.classList.remove('is-transition-in'); });
            locked = false;
          });
        });
      });
    }

    function goTo(index) {
      if (locked || index === active || index < 0 || index >= slides.length) return;
      locked = true;

      var targetIndex = index;
      var settled     = false;

      function done() {
        if (settled) return;
        settled = true;
        animTargets.forEach(function (el) { el.removeEventListener('transitionend', onEnd); });
        clearTimeout(fallbackId);
        finishTransition(targetIndex);
      }

      var ended = 0;
      var need  = animTargets.length;
      function onEnd(e) {
        if (e.propertyName !== 'opacity') return;
        ended += 1;
        if (ended >= need) done();
      }

      animTargets.forEach(function (el) { el.addEventListener('transitionend', onEnd); });
      var fallbackId = setTimeout(done, FALLBACK_MS);
      animTargets.forEach(function (el) { el.classList.add('is-transition-out'); });
    }

    // ── Wire up interactions — reset autoplay timer on manual navigation ──
    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        startAutoplay(); // reset the 3s countdown on manual click
        goTo(Number(btn.getAttribute('data-index')));
      });
    });

    bulletEls.forEach(function (btn) {
      btn.addEventListener('click', function () {
        startAutoplay();
        goTo(Number(btn.getAttribute('data-index')));
      });
    });

    if (progressTrack) {
      progressTrack.style.cursor = 'pointer';
      progressTrack.addEventListener('click', function (e) {
        var rect  = progressTrack.getBoundingClientRect();
        var ratio = (e.clientX - rect.left) / rect.width;
        ratio     = Math.max(0, Math.min(1, ratio));
        var index = Math.min(slides.length - 1, Math.floor(ratio * slides.length));
        startAutoplay();
        goTo(index);
      });
    }

    setProgress(0);
    startAutoplay();
  }

  function initAll() {
    document.querySelectorAll('.lux-chapters[data-section-id]').forEach(initSection);
  }

  initAll();

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector && e.target.querySelector('.lux-chapters[data-section-id]');
    if (root) initSection(root);
  });
})();